import React, { useEffect, useState } from 'react';
import { Image } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import noImage from 'assets/bw_image/no_image.svg';

const ImageStyled = styled(Image)`
  :where(.css-dev-only-do-not-override-12upa3x).ant-image .ant-image-mask:hover {
    opacity: 1 !important;
  }
`;

const isLegacyTnhImage = (src) => {
  const normalizedSrc = `${src || ''}`.toLowerCase();

  return (
    !normalizedSrc ||
    normalizedSrc.includes('tnh') ||
    normalizedSrc.includes('logo%20tnh') ||
    normalizedSrc.includes('logo_login') ||
    normalizedSrc.includes('default_img') ||
    normalizedSrc.includes('img_cate_')
  );
};

const normalizeImageSrc = (src, fallbackSrc) => (isLegacyTnhImage(src) ? fallbackSrc : src);

const isBaoChauLogo = (src) => `${src || ''}`.toLowerCase().includes('logo_baochau');

const composeImageClassName = (className, isFallbackImage, fallbackSrc) =>
  [
    className,
    isFallbackImage ? 'bw_fallback_image' : null,
    isFallbackImage && isBaoChauLogo(fallbackSrc) ? 'bw_baochau_logo_image' : null,
    isFallbackImage && !isBaoChauLogo(fallbackSrc) ? 'bw_no_image' : null,
  ]
    .filter(Boolean)
    .join(' ');

function BWImageItem({ src, fallbackSrc, className, alt, onError, ...props }) {
  const normalizedSrc = normalizeImageSrc(src, fallbackSrc);
  const [isFallbackImage, setIsFallbackImage] = useState(normalizedSrc === fallbackSrc);

  useEffect(() => {
    setIsFallbackImage(normalizedSrc === fallbackSrc);
  }, [normalizedSrc, fallbackSrc]);

  const handleError = (event) => {
    setIsFallbackImage(true);
    onError?.(event);
  };

  return (
    <ImageStyled
      src={normalizedSrc}
      fallback={fallbackSrc}
      alt={alt}
      className={composeImageClassName(className, isFallbackImage, fallbackSrc)}
      onError={handleError}
      {...props}
    />
  );
}

function BWImage({ src, fallbackSrc, className, alt, ...props }) {
  if (Array.isArray(src)) {
    return (
      <Image.PreviewGroup visible={true} {...props}>
        {src.map((item, index) => (
          <BWImageItem
            key={`${item || 'no-image'}-${index}`}
            src={item}
            fallbackSrc={fallbackSrc}
            alt={alt}
            className={className}
          />
        ))}
      </Image.PreviewGroup>
    );
  }

  return <BWImageItem src={src} fallbackSrc={fallbackSrc} alt={alt} className={className} {...props} />;
}

BWImage.propTypes = {
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  fallbackSrc: PropTypes.string,
  className: PropTypes.string,
  alt: PropTypes.string,
};

BWImage.defaultProps = {
  src: null,
  fallbackSrc: noImage,
  className: '',
  alt: '',
};
export default BWImage;
